import React from 'react';
import PropTypes from 'prop-types';
import { View } from '@react-pdf/renderer';
import {
    styles, preparePdfTheme, formatDate,
    PdfDocument, MetaCard, PartiesRow, LineItemsTable, TotalsCard, InfoCard,
} from './pdfCommon';

export { THEMES } from './pdfCommon';

/**
 * GrowSquare CRM invoice. Design, colour themes and shared pieces live in pdfCommon.js.
 * Optional props: theme (see THEMES in pdfCommon.js), logoSrc.
 */
const InvoicePDF = ({ data, companyData, tableItem, tableColum, currencySettings, Calculation, isCustomMode, profile, accountJsonData, theme, logoSrc }) => {
    const logo = logoSrc || companyData?.accountLogo;
    const p = {
        ...preparePdfTheme(theme, logo),
        logoRatio: companyData?.logoSize ? companyData.logoSize.width / companyData.logoSize.height : 1,
    };

    return (
        <PdfDocument
            documentTitle={`Invoice ${data?.invoiceNumber || ''}`}
            headline="INVOICE"
            number={data?.invoiceNumber}
            p={p}
            companyData={companyData}
            profile={profile}
        >
            <MetaCard
                items={[
                    ['Invoice date', formatDate(data?.invoiceDate, profile)],
                    ['Due date', formatDate(data?.dueDate, profile)],
                    data?.purchaseOrderNumber ? ['PO number', data?.purchaseOrderNumber] : null,
                ]}
            />

            <PartiesRow companyData={companyData} data={data} accountJsonData={accountJsonData} />

            <LineItemsTable
                tableItem={tableItem}
                tableColum={tableColum}
                isCustomMode={isCustomMode}
                currencySettings={currencySettings}
                profile={profile}
                p={p}
            />

            {/* Notes (left) next to the totals card (right); both stretch to the same height */}
            <View style={styles.totalsRow} wrap={false}>
                {data?.notes ? (
                    <InfoCard title="Notes" html={data.notes} p={p} style={styles.notesCard} />
                ) : null}
                <TotalsCard Calculation={Calculation} currencySettings={currencySettings} p={p} />
            </View>

            {data?.termsAndCondition ? (
                <InfoCard title="Terms and Conditions" html={data.termsAndCondition} p={p} style={{ marginTop: 14 }} />
            ) : null}
        </PdfDocument>
    );
};

InvoicePDF.propTypes = {
    data: PropTypes.object.isRequired,
    companyData: PropTypes.object.isRequired,
    tableItem: PropTypes.array.isRequired,
    tableColum: PropTypes.array.isRequired,
    currencySettings: PropTypes.object.isRequired,
    Calculation: PropTypes.object.isRequired,
    isCustomMode: PropTypes.bool.isRequired,
    profile: PropTypes.object.isRequired,
    accountJsonData: PropTypes.object.isRequired,
    theme: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    logoSrc: PropTypes.string,
};

InvoicePDF.defaultProps = {
    theme: 'growsquare',
    logoSrc: undefined,
};

export default InvoicePDF;